module.exports = __webpack_public_path__ + "static/media/3.a875ac13.png";